<template>
  <div class="wrapper">
    
    <parallax
      class="section page-header header-filter"
      :style="{ backgroundImage: 'url(' + header_pictures.products_header_picture.url + ')' }"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="products-section">
            
            <div class="products-container">
                <div class="navigation-breadcrumbs">
                    <router-link to="/">
                        <h5>Asiongs </h5>
                    </router-link>  
                    <h5>></h5>
                    <h5>Products</h5>
                </div>

                <h2>All Product Categories</h2>
                <br>
                <Loader v-if="categoriesloading" />
                <CategoriesContainer
                  :categories=categories
                  v-else
                ></CategoriesContainer>
                
                <br>
                
            </div>
            <div class="products-component">
              
              <ProductsComponent
                :categories=categories
              >
              </ProductsComponent>
            </div>
            
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/Loader.vue";
import CategoriesContainer from "@/components/CategoriesContainer.vue";
import ProductsComponent from "@/components/Searchproducts.vue";

export default {
  components: {
    Loader,
    CategoriesContainer,
    ProductsComponent
  },
  bodyClass: "profile-page",
  data() {
    return {
      productsloading: true,
      products: [],
      categoriesloading: true,
      categories: [],
    };
  },
  props: {
    header_pictures: Object,
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/categories?_sort=Name:ASC", {}).then(
      (response) => {
        this.categories = response.data;
        this.categoriesloading = false;
      },
      (error) => {
        // console.log(error);
      }
    );
    
  },
  computed: {
    
  },
  metaInfo() {
    return{
      title: 'Products',
      meta: [
        { name: 'description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:title', content: "Asiong's Industrial Products"},
        { property: 'og:description', content:  "Asiong's Industrial Products is an importer and distributor for general safety equipment. We provide an extensive range of industrial products and Personal Protective Equipment (PPE)."},
        { property: 'og:site_name', content: 'Asiongs Industrial Products'},
        { property: 'og:type', content: 'website'},    
        { property: 'og:image', content: this.header_pictures.products_header_picture.url}
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.navigation-breadcrumbs{
    display: flex;
    flex-flow: row wrap;
    margin-bottom: 24px;
    
    h5{
      margin: 0px 4px;
    }

  }
.category-card{
    display: flex;
    flex-direction: column;
}

.products-section{
    margin: 24px;
    

    .products-search{
        // float: right;
        padding: 12px;
        display: flex;
        flex-direction: row;
        max-width: 600px;

        .md-field{
            margin-right: 12px;
        }
    }

    .products-container{
        padding: 24px;
        max-width: 1440px;
        margin: auto;
        
    }   

    
}

.products-component{
  // border-top: 2px solid #eeeeee;
  margin: auto;
  max-width: 1440px;
  padding: 48px 0px;
}


</style>
